import classes from "./index.module.scss";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { contacts } from "./contacts";
import { v4 as uuid } from "uuid";
import { ReactComponent as Phone } from "./images/phone.svg";
import { ReactComponent as Mail } from "./images/mail.svg";
import { ReactComponent as Facebook } from "./images/facebook.svg";
import { ReactComponent as Telegram } from "./images/telegram.svg";
import { ReactComponent as Whatsapp } from "./images/whatsapp.svg";
import { ReactComponent as Instagram } from "./images/instagram.svg";
import { ReactComponent as Linkedin } from "./images/linkedin.svg";
import CardCreator from "./CardCreator";

export default function VCard() {
  const [employee, setEmployee] = useState(null);
  let { slug } = useParams();

  useEffect(() => {
    setEmployee(...contacts.filter((contact) => contact.slug === slug));
  }, [employee, slug]);

  if (!employee) {
    return null;
  }

  return (
    <div className={classes.container}>
      <div className={classes.body}>
        <div className={`${classes["image"]} ${classes["desktop-image"]}`}>
          <picture>
            <source srcSet={employee.images.photo.webp} type="image/webp" />
            <source srcSet={employee.images.photo.png} type="image/png" />
            <img
              src={employee.images.photo.png}
              alt={`${employee.firstName} ${employee.lastName}`}
              width={256}
              height={256}
            />
          </picture>
        </div>
        <div className={classes.content}>
          <div className={`${classes["image"]} ${classes["mobile-image"]}`}>
            <picture>
              <source srcSet={employee.images.photo.webp} type="image/webp" />
              <source srcSet={employee.images.photo.png} type="image/png" />
              <img
                src={employee.images.photo.png}
                alt={`${employee.firstName} ${employee.lastName}`}
                width={200}
                height={200}
              />
            </picture>
          </div>
          <div className={classes.heading}>
            <h1
              className={classes.title}
            >{`${employee.firstName} ${employee.lastName}`}</h1>
            <h3 className={classes.subtitle}>{employee.title}</h3>
          </div>
          <div className={classes.text}>
            {employee.text.map((p) => (
              <p key={uuid()} dangerouslySetInnerHTML={{ __html: p }} />
            ))}
          </div>
          <div className={classes["contacts-wrapper"]}>
            <employee.images.qr className={classes.qr} />
            <div className={classes.contacts}>
              <h3 className={classes.title}>Add me to your contacts</h3>
              <div className={`${classes["contacts-block"]} ${classes.phones}`}>
                <Phone />
                <div className={classes.numbers}>
                  {employee.work ? (
                    <a
                      className={classes["contact-link"]}
                      href={`tel:${employee.work.tel}`}
                    >
                      {employee.work.mask}
                    </a>
                  ) : null}
                  {employee.mobile ? (
                    <a
                      className={classes["contact-link"]}
                      href={`tel:${employee.mobile.tel}`}
                    >
                      {employee.mobile.mask}
                    </a>
                  ) : null}
                </div>
              </div>
              <div className={`${classes["contacts-block"]} ${classes.mail}`}>
                <Mail />
                <a
                  className={classes["contact-link"]}
                  href={`mailto:${employee.email}`}
                >
                  {employee.email}
                </a>
              </div>
              <div className={classes.social}>
                <a href={employee.telegram} target="_blank" rel="noreferrer">
                  <Telegram />
                </a>

                <a href={employee.whatsapp} target="_blank" rel="noreferrer">
                  <Whatsapp />
                </a>
                {employee.linkedin ? (
                  <a href={employee.linkedin} target="_blank" rel="noreferrer">
                    <Linkedin />
                  </a>
                ) : null}
                {employee.instagram ? (
                  <a href={employee.instagram} target="_blank" rel="noreferrer">
                    <Instagram />
                  </a>
                ) : null}
                {employee.facebook ? (
                  <a href={employee.facebook} target="_blank" rel="noreferrer">
                    <Facebook />
                  </a>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <CardCreator card={employee} />
      </div>
    </div>
  );
}
